import React from 'react'
import PropTypes from 'prop-types';

import {openPanel} from './sidePanel-action'

//http://animista.net/play/basic/scale-up/scale-up-ver-center
class SidePanel extends React.Component {
    static PANELS = {};
    static propTypes = {
        openerType: PropTypes.func.isRequired,
        openerAttrs: PropTypes.shape({
            onClick: PropTypes.func.isRequired
        }),
        containerId: PropTypes.string.isRequired
    }
    state = {}

    render() {
        const { openerType, openerAttrs, containerId } = this.props;
        const openerAction = openerAttrs.onClick;
        const action = e => {
            let promise = openerAction(e)
            if(!('function' === typeof promise.then)) {
                throw new Error('\'onClick\' on \'' + containerId + '\' open by ' + openerType.class + ' params should be a function returning a promise');
            }
            promise.then(data => {
                console.log('SidePanel > click > render data', data)
                !data.attrs && (data.attrs = {})
                data.attrs.close = SidePanel.PANELS[containerId].close;
                console.log('SidePanel data.attrs.close', data.attrs.close);
                return openPanel(containerId, data);
            });
            return promise;
        }
        openerAttrs.onClick = action;
        console.log('SidePanel', this.props, SidePanel.PANELS[containerId]);
        return React.createElement(openerType, {...openerAttrs})
    }
}

export default SidePanel
